<script>
import PagesDisplay from "@/components/PagesDisplay";

export default {
  components: {
    PagesDisplay,
  },
};
</script>

<template>
  <PagesDisplay page-type="legislative" :title="$t('views.legis')" />
</template>
